module.exports = __webpack_public_path__ + "static/media/email.ac267aca.svg";